// Stepts for homepage
const onboardingChecklistSteps = [
{
    element: ".table-responsive",
    popover: {
        className: 'first-step-popover-class',
        title: '🙋<br>Začínáme',
        description: '<b>Na této stránce máš přehled nad všemi interními úkoly,</b> které je potřeba zprocesovat v rámci preboardingu a onboardingu  zaměstnanců.',
        position: 'bottom',
        showButtons: true,
    },

},
{
    element: ".edit",
    popover: {
        className: 'image-popover',
        title: '<a href="../onboarding?profile=12" target="_blank" title="Více"><img src="/images/guide-onboarding-1.png"></a>',
        description: 'Úkoly se ti na tuto stránku propisují sami, stačí si je u jednotlivých zaměstnanců navolit. Kliknutím na ikonu <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-edit-3"><path d="M12 20h9"></path><path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4L16.5 3.5z"></path></svg> se proklikneš na zaměstnance, ke kterému úkol patří. 👌',
        position: 'bottom-right',
        showButtons: true,
    },

},
{
    element: "#sidebar",
    popover: {
        className: 'image-popover',
        title: '<a href="/onboarding/stranka?id=1&job=1#guide" target="_blank" title="Více"><img src="/images/guide-onboarding-3.png"></a>',
        description: '<b>Podívej se, jak onboarding vypadá pro zaměstnance (1 min).</b><br><br> V jednoduchém editoru můžeš připravit stránku, která se zobrazí zaměstnancům ve <b>zvolený čas</b> (před nástupem, 1. den atd.) na zvolené pozici.<br> Obsah můžeš doplnit podle sebe nebo použít naše ready-made šablony.',
        position: 'right-center',
        showButtons: true,
        doneBtnText: 'Ano, pokračovat dál',
        nextBtnText: 'Rozumím',        // Next button text for this step
        prevBtnText: 'Zpět',
    },
    onNext: () => {
        // Prevent moving to the next step
        window.location.assign("/onboarding/stranka?id=1&job=1#guide");

    }


},
]



export default onboardingChecklistSteps
